import { render } from "./IconTurnSharpLeft.vue?vue&type=template&id=2932194b"
import script from "./IconTurnSharpLeft.vue?vue&type=script&lang=js"
export * from "./IconTurnSharpLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__